<form
    (ngSubmit)="$event.preventDefault(); saveParentGuardian();"
    [formGroup]="parentGuardianForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Parent/Guardian Follow Up Steps
        </h2>
        <!-- <p class="font-semibold">
            For each item checked, please include specific information in the Record of Assigned Responsibilities (ROAR) portion regarding what steps will be taken, who is responsible, and the time frame for completion.
        </p> -->
        <div class="w-full flex flex-col items-center gap-2 pb-4">


            <div class="w-full flex flex-col gap-2">
                <div class="w-full font-semibold">
                    <p>Parents or guardians will provide the following supervision and/or intervention: *</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <!-- <div *ngFor="let option of options; let i = index">
                        <input type="radio" [id]="'option-' + i" value="{{ option }}" class="hidden peer"
                            formControlName="parent_follow_up"
                        >
                        <label [for]="'option-' + i"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-start text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            {{ option }}
                        </label>
                    </div> -->
                    <div *ngFor="let option of options; let i = index" class="flex items-center gap-2">
                        <input [id]="'option-' + i" value="{{ option }}" type="radio" formControlName="parent_follow_up"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500">
                        <label [for]="'option-' + i">
                            <h2 class="text-start flex items-center justify-between w-full font-medium">
                                {{ option }}
                            </h2>
                        </label>
                    </div>
                </div>
                <div *ngIf="parentGuardianForm.get('parent_follow_up')?.value !== options[0]" class="w-full flex flex-col items-center">
                    <div class="w-full font-semibold">
                        <p>Describe/explain. *</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <textarea
                            formControlName="parent_follow_up_notes"
                            rows="3"
                            class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                            placeholder="Type here..."></textarea>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Does this section require one or more assigned responsibilities to manage and support in the ROAR? *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="parent_follow_up_roar_yes" value="{{ yesNo.Yes }}" class="hidden peer"
                            formControlName="parent_follow_up_roar"
                        >
                        <label for="parent_follow_up_roar_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="parent_follow_up_roar_no" value="{{ yesNo.No }}" class="hidden peer"
                            formControlName="parent_follow_up_roar"
                        >
                        <label for="parent_follow_up_roar_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.parentGuardianForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.parentGuardianForm.valid
                }"
                [disabled]="this.parentGuardianForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>